import React, { useState } from 'react';
import { useSpring, config } from 'react-spring';
import PropTypes from 'prop-types';
import Container from '../components/Container';
import Card from '../components/Card';
import RainEffect from './components/RainEffect';
import WaveEffect from './components/WaveEffect';

import './Services.scss';

const CodeIcon = () => <i className="fa-solid fa-code fa-3x"></i>;
const PenRulerIcon = () => <i className="fa-solid fa-pen-ruler fa-3x"></i>;

const ServiceCard = ({ children }) => {
  const [isHover, setIsHover] = useState(false);

  const serviceStyles = useSpring({
    config: { ...config.wobbly },
    from: { scale: 1 },
    to: { scale: isHover ? 1.05 : 1 },
  });

  return (
    <Card
      className="text-center shadow-on-hover-lg border-0 h-100 p-4"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{ ...serviceStyles }}
    >
      {children}
    </Card>
  );
};

function Services({ id, ...props }) {
  return (
    <section id={`${id}-section`} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 240">
        <path
          fill="var(--dp-dark-2)"
          fillOpacity="1"
          d="M0,160L6.2,176C12.3,192,25,224,37,208C49.2,192,62,128,74,90.7C86.2,53,98,43,111,74.7C123.1,107,135,181,148,186.7C160,192,172,128,185,112C196.9,96,209,128,222,138.7C233.8,149,246,139,258,144C270.8,149,283,171,295,197.3C307.7,224,320,256,332,229.3C344.6,203,357,117,369,101.3C381.5,85,394,139,406,176C418.5,213,431,235,443,208C455.4,181,468,107,480,106.7C492.3,107,505,181,517,197.3C529.2,213,542,171,554,133.3C566.2,96,578,64,591,74.7C603.1,85,615,139,628,154.7C640,171,652,149,665,138.7C676.9,128,689,128,702,122.7C713.8,117,726,107,738,96C750.8,85,763,75,775,74.7C787.7,75,800,85,812,90.7C824.6,96,837,96,849,106.7C861.5,117,874,139,886,149.3C898.5,160,911,160,923,160C935.4,160,948,160,960,160C972.3,160,985,160,997,170.7C1009.2,181,1022,203,1034,186.7C1046.2,171,1058,117,1071,128C1083.1,139,1095,213,1108,229.3C1120,245,1132,203,1145,170.7C1156.9,139,1169,117,1182,106.7C1193.8,96,1206,96,1218,90.7C1230.8,85,1243,75,1255,74.7C1267.7,75,1280,85,1292,106.7C1304.6,128,1317,160,1329,181.3C1341.5,203,1354,213,1366,218.7C1378.5,224,1391,224,1403,213.3C1415.4,203,1428,181,1434,170.7L1440,160L1440,0L1433.8,0C1427.7,0,1415,0,1403,0C1390.8,0,1378,0,1366,0C1353.8,0,1342,0,1329,0C1316.9,0,1305,0,1292,0C1280,0,1268,0,1255,0C1243.1,0,1231,0,1218,0C1206.2,0,1194,0,1182,0C1169.2,0,1157,0,1145,0C1132.3,0,1120,0,1108,0C1095.4,0,1083,0,1071,0C1058.5,0,1046,0,1034,0C1021.5,0,1009,0,997,0C984.6,0,972,0,960,0C947.7,0,935,0,923,0C910.8,0,898,0,886,0C873.8,0,862,0,849,0C836.9,0,825,0,812,0C800,0,788,0,775,0C763.1,0,751,0,738,0C726.2,0,714,0,702,0C689.2,0,677,0,665,0C652.3,0,640,0,628,0C615.4,0,603,0,591,0C578.5,0,566,0,554,0C541.5,0,529,0,517,0C504.6,0,492,0,480,0C467.7,0,455,0,443,0C430.8,0,418,0,406,0C393.8,0,382,0,369,0C356.9,0,345,0,332,0C320,0,308,0,295,0C283.1,0,271,0,258,0C246.2,0,234,0,222,0C209.2,0,197,0,185,0C172.3,0,160,0,148,0C135.4,0,123,0,111,0C98.5,0,86,0,74,0C61.5,0,49,0,37,0C24.6,0,12,0,6,0L0,0Z"
        ></path>
      </svg>
      <Container
        id={id}
        title="SERVICES"
        titleClassName="underline fw-bold"
        headerClassName="mb-5"
      >
        <div className="row gy-4 justify-content-center pb-4">
          <div className="col-12 col-md-6 col-lg-4 col-xl-3">
            <ServiceCard>
              <div className="mb-4">
                <PenRulerIcon />
              </div>
              <div className="mb-2">
                <h4 className="fw-bold">Design</h4>
                <p>
                  I value simple content structure, clean design patterns, and
                  thoughtful interactions.
                </p>
              </div>
              <div className="mb-2">
                <h4 className="fw-bold">Things I enjoy doing</h4>
                <p>UI, Web, Photos, Logos</p>
              </div>
              <div className="mb-2">
                <h4 className="fw-bold">Tools I use</h4>
                <p>Photoshop, Figma</p>
              </div>
            </ServiceCard>
          </div>
          <div className="col-12 col-md-6 col-lg-4 col-xl-3">
            <ServiceCard>
              <div className="mb-4">
                <CodeIcon />
              </div>
              <div className="mb-2">
                <h4 className="fw-bold">Web Development</h4>
                <p>
                  I like to code things from scratch, and enjoy bringing ideas
                  to life in the browser.
                </p>
              </div>
              <div className="mb-2">
                <h4 className="fw-bold">Things I enjoy doing</h4>
                <p>HTML, CSS, Javascript</p>
              </div>
              <div className="mb-2">
                <h4 className="fw-bold">Tools I use</h4>
                <p>VSCode, React, Redux, Codesandbox, Github</p>
              </div>
            </ServiceCard>
          </div>
        </div>
      </Container>
      <RainEffect />
      <WaveEffect />
    </section>
  );
}

Services.defaultProps = {
  id: 'services',
};

Services.propTypes = {
  id: PropTypes.string,
};

export default React.memo(Services, (prev, next) => true);
